<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        广告列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto" class="filtrate">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">
          <i class="fas fa-bars"></i>
          数据列表
        </div>
      </div>
      <div class="table">
        <el-table :data="newBrand" ref="multipleTable" border style="width: 100%">
          <el-table-column label="编号" prop="index" style="text-align:center"></el-table-column>
          <el-table-column v-model="tower_name" prop="title" label="广告名称" width="150"></el-table-column>
          <el-table-column prop="link" width="300" label="链接地址"></el-table-column>
          <el-table-column prop="auth" label="修改人"></el-table-column>
          <el-table-column width="180" prop="update_date" label="修改时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                @click="get_info(scope.row.id)"
                type="text"
                style="hover:color:#0099FF;color:#333"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>
   

<script>
import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      newBrand: [],
      tower_name: "",
      username: "",
      token: ""
    };
  },

  created() {
    this.$store.state.leftTitle = "横幅广告";
    this.$store.state.topActiveId = 7;
    this.getData();
  },
  methods: {
    get_info(id) {
       this.$router.push({
          path: "g_addAdvering/" + id
        });
    },
    getData(page) {
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/banner_ad_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var json = res.data.data;
          that.newBrand = [];
          if (res.data.status == "success") {
            for (var key in json) {
              var time = json[key].update_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json[key].index =parseInt(key) + 1
              json[key].update_date = timeNew
              that.newBrand.push(json[key]);
            }
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>

<style lang="scss">
.topBar {
  margin-bottom: 40px;
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}

.filtrate {
  width: 1060px;
  height: 100%;
  margin-left: 420px;
  // background: orange;
  span:hover {
    color: #0099ff;
  }
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}
.brand-page {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;

  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }
  .create {
    float: right;
    margin-right: 20px;
    padding-top: 7px;
  }
  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .el-table th > .cell {
    text-align: center;
  }
  .cell {
    text-align: center;
  }
}
</style>

